module.exports = __webpack_public_path__ + "static/media/leftarrow.ad58be06.svg";